//Subcomponent shared by step view and status page.

import React, { useEffect, useState } from "react"

import Check from "images/inline/receipt/check.svg"
import Pending from "images/inline/receipt/pending.svg"
import X from "images/inline/receipt/x.svg"
import "./Status.scss"
//submitted, approved, rejected

const ReceiptStatus = ({ status = "submitted", onStatusRetrieved }) => {
  const [statusCopy, setStatusCopy] = useState(null)
  const assignStatusCopy = status => {
    if (status === "SUBMITTED") {
      return { dialogueTitle: "Your receipt has been submitted", icon: <Pending />, dialogueText: "Your receipt has been submitted and is pending approval. It may take 3-5 days to be approved." }
    } else if (status === "APPROVED") {
      return { dialogueTitle: "Your receipt has been approved", icon: <Check />, dialogueText: "Thank you for your submission! Your receipt has been approved. Please check your email to claim your reward." }
    } else if (status === "REJECTED") {
      return { dialogueTitle: "Receipt Not Approved", icon: <X />, dialogueText: "REASON FOR REJECTION: We can’t read your receipt. Be sure it’s in focus, well lit, and the entire receipt is visible, including store, items purchased, and purchase date." }
    } else {
      return { dialogueTitle: "Your receipt has been submitted", icon: <Pending />, dialogueText: "Your receipt has been submitted and is pending approval. It may take 3-5 days to be approved." }
    }
  }

  useEffect(() => {
    setStatusCopy(assignStatusCopy(status))
    onStatusRetrieved && onStatusRetrieved(status)
  }, [status])
 

 
  return (
    <div className="receipt-status">
      {statusCopy && (
        <div className={`receipt-status-dialogue`}>
          <div className={`receipt-status-icon`}>
            <div className="receipt-status-icon-element">{statusCopy.icon}</div>
          </div>
          <h3 className={`receipt-status-dialogue-desc`}>Status: {statusCopy.dialogueTitle}</h3>
        </div>
      )}
    </div>
  )
}
export default ReceiptStatus
